
import React from 'react';

interface QuickActionsProps {
  onSelect: (question: string) => void;
}

export const QuickActions: React.FC<QuickActionsProps> = () => {
  const quickQuestions = [
    "Find a Bible Verse",
    "Help Me Pray", 
    "Explain a Bible Word",
    "Answer a Tough Question"
  ];
  
  return (
    <div className="p-3 border-t border-gray-100">
      <p className="text-xs text-gray-500 mb-2 font-medium">Quick Suggestions:</p>
      <div className="flex flex-wrap gap-2">
        {quickQuestions.map((question, index) => (
          <span 
            key={index} 
            className="text-xs px-2 py-1 rounded bg-gray-100 text-gray-600"
          >
            {question}
          </span>
        ))}
      </div>
    </div>
  );
};
